import {Maps} from './Maps'

(function () {

    // Hotels Group
    if (document.querySelector('#hotels')) {
        const Hotels = new Maps.HotelFinder(document.querySelector('#hotels'))

        const $subNavLinks = document.querySelectorAll('[href*="#hotels?"]')
        $subNavLinks.forEach(function ($link) {
            $link.addEventListener('click', function (e) {
                e.preventDefault()
                const filterVal = this.getAttribute('href').split('?')[1]
                Hotels.setCat(filterVal)
                const $HotelSheet = document.querySelector('#hotel-list-sheet')
                $HotelSheet.getNav().setDelayOverride(true)
                $HotelSheet.getNav().open()
                $HotelSheet.getNav().setDelayOverride(false)
            })
        })
    }

    // Hotels Single
    const $hotSpots = document.querySelector('#hotspots')
    if($hotSpots) new Maps.HotSpots($hotSpots)

})()